module.exports = __webpack_public_path__ + "static/wrkat-extraimg3@2x-min-5258dda66a500f8846fdcf69dc54b2ba.png";